export enum ClubRequired {
	Ignore = "ignore",
	Optional = "optional",
	Required = "required",
}
